__turbopack_context__.v({
  "skeleton": "_3YhRtG_skeleton",
  "text--hidden": "_3YhRtG_text--hidden",
  "wrapper": "_3YhRtG_wrapper",
});
